import { useViewport } from 'contexts/viewport';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormLabel, Paper, Stack, styled, Switch, Text } from 'shell/components';
import { isInlineCommentsSettingsDefault } from 'utils/helper';

const InlineCommentsSection = memo(({ isEditable, form, setForm, setInlineCommentsSettingsDialog }) => {
    const { device } = useViewport();
    const { t } = useTranslation('assignment');

    const getText = () => {
        return !isInlineCommentsSettingsDefault(form.inlineCommentsSettings)
            ? t('custom-settings', 'Custom settings')
            : t('system-default', 'System Default');
    };

    return (
        <Stack sx={{ width: '100%' }} spacing={1}>
            <Text variant={'p1'}>{t('inline-comments-section.title', 'Inline Comments')}</Text>
            <CustomPaper variant={'outlined'}>
                <Stack spacing={4}>
                    <CustomPaper variant={'outlined'}>
                        <Stack spacing={3}>
                            <Stack
                                alignItems={device === 'mobile' ? 'flex-start' : 'center'}
                                direction={'row'}
                                justifyContent={'space-between'}
                            >
                                <Text variant={'p1'}>
                                    {t('inline-comments-section.inline-comments-settings', 'Inline Comments Settings')}
                                </Text>
                                <Button
                                    disabled={!isEditable || !form.aiInlineCommentsEnabled}
                                    variant={'borderless'}
                                    onClick={() => setInlineCommentsSettingsDialog({ open: true })}
                                >
                                    {t('advanced-settings', 'Advanced Settings')}
                                </Button>
                            </Stack>
                            <Text color={'light'}>{getText()}</Text>
                        </Stack>
                    </CustomPaper>
                    <Stack spacing={2}>
                        <Stack
                            alignItems={'center'}
                            direction={'row'}
                            justifyContent={device === 'mobile' ? 'space-between' : 'initial'}
                            spacing={4}
                        >
                            <FormLabel id={'inline-comments-switch'}>
                                <Text variant={'p1'}>
                                    {t(
                                        'inline-comments-section.automatically-generate-inline-comments',
                                        'Automatically generate inline comments?'
                                    )}
                                </Text>
                            </FormLabel>
                            <Switch
                                aria-labelledby={'inline-comments-switch'}
                                checked={form.aiInlineCommentsEnabled}
                                disabled={!isEditable}
                                onChange={(_, value) =>
                                    setForm((current) => ({ ...current, aiInlineCommentsEnabled: value }))
                                }
                            />
                        </Stack>
                        <Text>
                            {t(
                                'inline-comments-section.inline-comments-description',
                                "Inline comments are distinct from overall feedback. They provide contextual insights directly on the student's work tied to feedback and/or grading suggestions. If this option is disabled, you will still be able to add your own comments manually."
                            )}
                        </Text>
                    </Stack>
                </Stack>
            </CustomPaper>
        </Stack>
    );
});

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        padding: theme.spacing(4),
    };
});

export default InlineCommentsSection;
